import { defineStore } from 'pinia'
import { sendApi } from '@/utils/api'
function dataRender (data){
  return data.map(item => ({
    id: item.id,
    name: item.name,
    family: item.family,
    mobile: item.mobile,
    gmail: item.gmail,
    qr_code_url: item.qr_code_url??'',
    image: item.image,
    finger: item.finger
  }))
}
export const useUserStore = defineStore('user', {
  state: () => ({
    card: {
      qr_code_url:'',
      name:'',
      family:'',
      mobile: '',      
      gmail: '',
      image: '',
      finger:false,
    },
    qr_code_url:'',
    name: '',
    family: '',
    mobile: '',
    gmail: '',
    image: '',
    finger:false, 
    isLoaded: false,
    userIdQrCodeScan: 0,
    nameQrCodeScan: '',
    familyQrCodeScan: '',
    mobileQrCodeScan: '',
    gmailQrCodeScan: '',
    imageQrCodeScan: '',
    showTemplateAfterLogin:''
  }),
  actions: {
    async savePhone(phone){
      try {
        const response = await sendApi({ 
          data: phone,
          action: 'save_phone',
          control:'login'
        })
        return response.status === 'success'
      } catch (e) {
        console.error('خطا در ارسال شماره:', e)
        return false
      }
    },
    async removePhone(){
      try {
        const responseDel = await sendApi({ 
          control:'security',
          action: 'delete_phone'
        })
        return responseDel.status === 'success'
      } catch (e) {
        console.error('خطا در حذف شماره:', e)
        return false
      }
    },
    async sendLoginCode(phone){
      try {
        const response = await sendApi({ 
          action: 'send_phone_login',
          data: phone,
          control:'login'
        })
        return response.status === 'success'    
      } catch (error) {
        console.error(error)
        return false
      }
    },
    async hasFinger(){
      try {
        const response = await sendApi({ 
          action:'check_mobile_has_finger_print',
          control:'login' 
        })
        return !!response && response.status === 'success'
      } catch (error) {
        console.error('خطا در ارتباط با سرور:', error)
        return false
      }
    },
    async fingerPrintLoginRequest(){
      try {
        return await sendApi({
          action: 'login_webauthn_request',
          control:'login'
        })
      }catch(e){
        console.error(e)
        return false
      }
    },
    async fingerPrintLoginResponse(credential){
      try{
        return await sendApi({
          data:credential,
          action: 'login_webauthn_response',
          control:'login'
        })
      }catch(e){
        console.error(e)
        return false
      }
    },
    async fingerPrintRegisterRequest(){
      try {
        return await sendApi({
          action: 'register_webauthn_request',
          control:'login'
        })
      }catch(e){
        console.error(e)
        return false
      }
    },
    async fingerPrintRegisterResponse(options){
      try{
        return await sendApi({
          action: 'register_webauthn_response',
          data: options,
          control:'login'
        })
      }catch(e){
        console.error(e)
        return false
      }
    },
    async resendCode(phone){
      try {
        const response = await sendApi({ 
          data: phone,
          action: 'send_phone_login',
          control:'login'
        })
        return response.status === 'success'
      } catch (error) {
        console.error(error)
        return false;
      }
    },
    async verifySmsCode(phone,code){
      try {
        return await sendApi({
          action: 'verify_sms_code',
          data: { phone: phone, code: code },
          control:'login'
        })
      } catch (error) {
        console.error(error)
        return false;          
      }
    },
    async logOut(){
      try{
        const res = await sendApi({ action: 'logout' , control:'security' });
        if (res.status === 'success'){
          this.qr_code_url= ''
          this.name= ''
          this.family= ''
          this.mobile= ''
          this.gmail= ''
          this.image= ''
          this.finger=false
          this.card.qr_code_url= ''
          this.card.name= ''
          this.card.family= ''
          this.card.mobile= ''
          this.card.gmail= ''
          this.card.image= ''
          this.card.finger=false
          this.isLoaded = false
          return true
        }else{
          return false
        }
      }catch(e){
        console.error(e)
        return false
      }
    },
    async register(name,family,image_id){
      try {
        const response = await sendApi(
          {
            action: 'register_user',
            data: {
              name: name,
              family: family,
              image_id: image_id
            },
            control:'login'
          }
        )
        return response.status === 'success'
      } catch (error) {
        console.error(error)
        return false;
      }
    },
    async fetchUserInfo() {
      try {
        const res = await sendApi({ action: 'get_user_info', control: 'user' })
        if (res.status === 'success') {
          const item = [];
          item[0]=res
          const render = dataRender(item)
          this.setUserInfo(render[0])
          this.isLoaded = true
          return render[0]
        } else {
          console.warn('User info error:', res)
        }
      } catch (err) {
        console.error('Error fetching user:', err)
      }
    },
    async edit(name,family,image_id){
      try {
        const res = await sendApi({
          control: 'user',
          action: 'edit_user',
          data: {
            name: name,
            family: family,
            image_id: image_id,
          },
        })
        return res.status==='success'
      } catch (e) {
        console.error(e)
        return false
      }
    },
    isLoggedIn(){
      this.fetchUserInfo();
      return ((this.name!=='' || this.family!=='') && this.mobile!=='')
    },
    setUserInfo(res){
      this.qr_code_url = res.qr_code_url??''
      this.name = res.name??''
      this.family = res.family??''
      this.mobile = res.mobile??''      
      this.gmail = res.gmail??''
      this.image = res.image??''
      this.finger = res.finger??false
      this.card.qr_code_url = res.qr_code_url??''
      this.card.name = res.name??''
      this.card.family = res.family??''
      this.card.mobile = res.mobile??''      
      this.card.gmail = res.gmail??''
      this.card.image = res.image??''
      this.card.finger = res.finger??false
    },
    async getUserDataQrCodeScan(a){
      const id=parseInt(a)
      if(id > 0){
        if(this.userIdQrCodeScan===id) return
        try {
          const res = await sendApi({ data: { id : id }, action: 'get_user_info_by_id', control: 'user' })
          if (res.status === 'success') {
            this.userIdQrCodeScan = id
            this.nameQrCodeScan = res.data?.name??''
            this.familyQrCodeScan = res.data?.family??''
            this.mobileQrCodeScan = res.data?.mobile??''
            this.gmailQrCodeScan = res.data?.gmail??''
            this.imageQrCodeScan = res.data?.image??''
          } else {
            console.warn('User info error:', res)
          }
        } catch (err) {
          console.error('Error fetching user:', err)
        }
      }
    },
    resetScan(){
      this.nameQrCodeScan = ''
      this.familyQrCodeScan = ''
      this.mobileQrCodeScan = ''
      this.gmailQrCodeScan = ''
      this.imageQrCodeScan=''
      this.userIdQrCodeScan = 0
    },
    async scanUser(id){
      try{
        const res = await sendApi({ data: { id : id }, action: 'scan_action', control: 'user' })
        return res.status === 'success'
      } catch (err) {
        console.log(err);
      }
    },
    async visitAction(t){
      try{
        const res = await sendApi({ data: { id : this.userIdQrCodeScan , type : t }, action: 'visit_action', control: 'user' })
        return res.status === 'success'
      } catch (err) {
        console.log(err);
      }
    },
    loginNeed(id){
      this.showTemplateAfterLogin='/show-user-card/'+id
    },
    loginNeeded(){
      this.showTemplateAfterLogin='/add-product'
    },
    loginNeededFac(id){
      this.showTemplateAfterLogin='/add-factor/'+id
    },
    resetLoginNeed(){
      this.showTemplateAfterLogin=''
    }
  },
})